const items = [
  "100% Human Hair",
  "Hand-Tied Lace",
  "Made in America",
  "Cruelty-Free",
  "Heat-Safe",
  "Pre-Plucked Hairlines",
  "Single Donor Bundles",
  "Tailored to You",
];

export const Marquee = () => {
  return (
    <div
      data-testid="marquee-section"
      className="relative border-y border-white/5 bg-[#0a0705] py-6 overflow-hidden"
    >
      <div className="flex marquee whitespace-nowrap">
        {[...items, ...items].map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-12 px-6 text-[#A39791] font-body uppercase tracking-[0.35em] text-xs sm:text-sm"
          >
            <span>{item}</span>
            <span className="gold-text">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
